module.exports = __webpack_public_path__ + "img/f9.db9d22d4.jpg";